module.exports = __webpack_public_path__ + "static/img/partner-zjjc.75cc63b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-zjjc.png
// module id = my+U
// module chunks = 34